export default {
    RIBBON_HEIGHT: 56,
    /* routes */
    ROUTES: {
        DEFAULT_ROUTE: '/',
        NOT_FOUND_REDIRECT: '/notFoundRedirect',
        OAUTH_CALLBACK: '/oauth/callback',
    },
    /* units */
    UNITS: {
        KILOMETERS: 'KM',
        MILES: 'MILE',
    },
    UNIT_SETTINGS: {
        CO2_DISTANCE_RATIO_KEY: 'CO2_DISTANCE_RATIO',
        DISTANCE_KEY: 'DISTANCE',
        FUEL_CONSUMPTION_KEY: 'FUEL_CONSUMPTION',
        FUEL_KEY: 'FUEL',
        SPEED_KEY: 'SPEED',
    },
};
export const projectCode = 'iftar';
export var ApiStatus;
(function (ApiStatus) {
    ApiStatus["ERROR"] = "error";
    ApiStatus["IDLE"] = "idle";
    ApiStatus["LOADING"] = "loading";
    ApiStatus["RESOLVED"] = "resolved";
})(ApiStatus || (ApiStatus = {}));
export var MessagePrefix;
(function (MessagePrefix) {
    MessagePrefix["IftaReporting"] = "ifta-reporting";
    MessagePrefix["Linton"] = "linton";
})(MessagePrefix || (MessagePrefix = {}));
export var CUSTOM_CLOUDWATCH_LEVEL;
(function (CUSTOM_CLOUDWATCH_LEVEL) {
    CUSTOM_CLOUDWATCH_LEVEL["SESSION"] = "SESSION";
})(CUSTOM_CLOUDWATCH_LEVEL || (CUSTOM_CLOUDWATCH_LEVEL = {}));
export var LocalStorageKeys;
(function (LocalStorageKeys) {
    LocalStorageKeys["APP_INIT_TRIES"] = "app_init_tries";
})(LocalStorageKeys || (LocalStorageKeys = {}));
// How many times should application try to request
// new authorization code from IdP and refresh
// on initialization error
export const MAX_APP_INIT_TRIES = 2;
export var UserSettingKey;
(function (UserSettingKey) {
    UserSettingKey["selectedResource"] = "selected-resource";
})(UserSettingKey || (UserSettingKey = {}));
export const DEFAULT_LOCALE = 'en-GB';
